import React, { useEffect } from 'react';
import styled from 'styled-components';

import GemContainer from './components/GemContainer';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: #000;
  overflow: hidden;
`;

const CloseButton = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 2100;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.85);
  }

  &:focus {
    outline: 0;
  }
`;

interface GemOverlayProps {
  onClose: () => void;
}

export default function GemOverlay({ onClose }: GemOverlayProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <Overlay>
      <CloseButton onClick={onClose} aria-label='Kilépés'>
        ×
      </CloseButton>
      <GemContainer />
    </Overlay>
  );
}
